export default __webpack_public_path__ + "src/assets/uniseth.74972d3f6525a39841b9494ba1169c2a.svg";